import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import {getTextsByPage} from "@/api/customTexts";


@Module({ dynamic: true, store, name: 'breadCrumbs' })
class Other extends VuexModule {
  public showModalWindowFull: boolean = false;
  public pageNameInModalWindowFull: string = '';

  @Mutation
  private CHANGE_SHOW_MODAL_WINDOW_FULL(value: boolean) {
    this.showModalWindowFull = value;
  }


  @Action
  async onShowModalWindowFull(value: boolean) {
    await this.CHANGE_SHOW_MODAL_WINDOW_FULL(value);
  }
  @Action
  async onShowModalWindowFullReset() {
    await this.CHANGE_SHOW_MODAL_WINDOW_FULL(false);
    await this.CHANGE_PAGE_NAME_MODAL_WINDOW_FULL('');
  }

  @Mutation
  private CHANGE_PAGE_NAME_MODAL_WINDOW_FULL(value: string) {
    this.pageNameInModalWindowFull = value;
  }


  @Action
  async onChangePageNameInModalWindowFull(value: string) {
    await this.CHANGE_PAGE_NAME_MODAL_WINDOW_FULL(value);
  }

  @Action
  async getCustomTexts(pageTitle: string) {
    try {
      return await getTextsByPage(pageTitle);
    } catch (error) {
      console.log(error);
    }
  }

}

export const OtherModule = getModule(Other);
